import { Skeleton } from '@stone-payments/jade';

export function DigitalWalletsSkeleton() {
  return (
    <div data-testid="digital-wallet-choice" className="border-0 flex flex-col gap-jade-200">
      <Skeleton height="24px" width="200px" cornerRadius="medium" />
      <div className="flex items-center gap-jade-200">
        <Skeleton height="30px" width="100%" cornerRadius="medium" />
        <Skeleton height="30px" width="100%" cornerRadius="medium" />
      </div>
    </div>
  );
}
